import { Component, Inject, Input, OnInit, OnChanges, OnDestroy, EventEmitter, Output } from "@angular/core";
import { DialogService } from "../../../../services/dialog.service";
import { HttpClient } from "@angular/common/http";
import { DefaultValuesService } from "../../../../services/defaultvalues.service";
import { MatDialog } from "@angular/material/dialog";
import { CustomDialogService } from '../../../../services/customdialog.service';
import { animate, state, style, transition, trigger } from "@angular/animations";
import { KpiDetailFormComponent } from "../../kpimanagement/kpidetail-form.component";
import { MatTableDataSource } from "@angular/material/table";
import { Subject } from "rxjs";
import { Utils } from "../../../../utils/utils";
import { SelectionModel } from "@angular/cdk/collections";
import { FilterUtils } from "../../shared-components/filter/filter-utils";

@Component({
    selector: "pe-yearlyplanning-list",
    templateUrl: './pe-yearlyplanning-list.component.html',
    styleUrls: ['./pe-yearlyplanning-list.component.less',
        '../../../../style/new-generic-styles.component.less'],
    standalone: false,
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*', })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ]

})

export class PeYearlyPlanningListComponent implements OnInit, OnChanges, OnDestroy {
    @Input('list') list: TaxKpiManagement[] = [];
    @Input('filter') filter: string = ''

    @Input('isEditModeEnabled') isEditModeEnabled: boolean = false;
    @Input('isApprovalModeEnabled') isApprovalModeEnabled: boolean = false;

    @Input('auxFilterPredicate') auxFilterPredicate!: (filters: string, data: any, parentLevel: boolean, showAllEnabled: boolean) => boolean;
    @Input('isShowAllEnabled') isShowAllEnabled: boolean = false;

    @Input('isRevokeActive') isRevokeActive: boolean = false;
    @Input('isReleaseActive') isReleaseActive: boolean = false;
    @Output() onClickReleaseMode: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() onClickRevokeMode: EventEmitter<boolean> = new EventEmitter<boolean>();

    currentFY: string | undefined;
    FY1: string | undefined;
    FY2: string | undefined;
    FY3: string | undefined;

    columnsToDisplay = ['arrow', 'Account', 'KpiName', 'KpiOwner', 'KpiUnit', 'LocalCurrency', 'AvailabilityTime', 'ReportingType', 'actions'];

    public dataSource: MatTableDataSource<TaxKpiManagement>

    expandedElements = new Set();
    isAllCollapsed = false;

    protected _onDestroy = new Subject<void>();

    updatedItems: TaxKpiManagementUpdate[] = [];

    releaseList: selectedReleaseRow[] = []
    selection = new SelectionModel<UserSummary>(true, []);

    constructor(
        private http: HttpClient
        , private dialogService: DialogService
        , private defaults: DefaultValuesService
        , @Inject('BASE_URL') private baseUrl: string
        , private customDialog: CustomDialogService
        , private dialogForm: MatDialog

    ) {
        this.dataSource = new MatTableDataSource<TaxKpiManagement>();
    }

    ngOnInit() {
        this.dialogService.tthis = this;
        this.dataSource.filterPredicate = (data: TaxKpiManagement, filters: string) => {
            const filterList = filters ? filters.split('+').map(f => f.trim()).filter(f => f) : [];
            filterList.pop();
            
            if (filterList.length === 0) {
                if (data.subtable) {
                    data.subtable.filter = '__FORCE__';
                } else {
                    this.createMatSubtable(data);
                    data.subtable.filter = '__FORCE__';
                }
                return true;
            }
            
            return FilterUtils.applyCommonFilterLogic(
                data,
                filterList,
                this.dataSource,
                this.auxFilterPredicate.bind(this),
                this.createMatSubtable.bind(this),
                this.isShowAllEnabled
            );
        };
        
        this.dataSource.data = Utils.deepCopyArray(this.list)
        this.dataSource.filter = this.filter;
    }

    ngOnChanges(changes: any) {
        this.getFiscalYearHeaders();
        if (changes.list) {
            this.dataSource.data = Utils.deepCopyArray(this.list)
            this.expandedElements.clear()
            this.updatedItems = [];
        }

        if (changes.filter || changes.inclusiveFilter || changes.selectorFilter) {
            this.dataSource.filter = this.filter;
        }

        if (changes.isApprovalModeEnabled) {
            this.expandedElements.clear()
            this.updatedItems = []
        }
    }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    pushPopElement(element) {
        if (this.expandedElements.has(element.AccountID)) {
            this.expandedElements.delete(element.AccountID);
        }
        else {
            this.expandedElements.add(element.AccountID);
            if (!element.subtable) {
                this.createMatSubtable(element)
            }
        }
    }

    checkExpanded(element) {
        return this.expandedElements.has(element.AccountID);
    }

    collapseOrExpandAll() {
      if (this.isAllCollapsed === false) {
        this.isAllCollapsed = true;
        this.dataSource.data.forEach((el: any) => {
          if (!this.expandedElements.has(el)) {
            if (!el.subtable) {
              this.createMatSubtable(el)
            }
            this.expandedElements.add(el.AccountID);
          }
        })
      }
      else {
        this.isAllCollapsed = false;
        this.expandedElements.clear()
      }
    }

    accountItemsSelected(ischecked, row) {
        row.KpiDetail.forEach((item) => {
            this.isReleaseActive ? (item.ApprovalStatus == "NEW" ? this.expandedItemSelected(ischecked, item) : null) :
                (item.ApprovalStatus == "RELEASED" ? this.expandedItemSelected(ischecked, item) : null)
        });

    }

    accountCheckboxCheck(row) {
        var checked = row.KpiDetail.every((row) => {
            var mappedRow = this.mapReleaseRow(row);
            return this.releaseList.some((object) => this.objectsEqual(mappedRow, object));
        });
        return checked;
    }

    accountItemsIndetermine(row) {
        var indeterminate = this.releaseList.some((selected) => (selected.KpiDefinitionId === row.KpiDefinitionId));
        return indeterminate;
    }

    accountItemsDisable(row) {
        var disable = !row.KpiDetail.some((item) => {
            return (this.isReleaseActive ? (item.ApprovalStatus == "NEW") :
                (item.ApprovalStatus == "RELEASED"))
        });
        return disable;
    }

    expandedItemSelected(ischecked, row) {
        if ((this.isReleaseActive || this.isRevokeActive) && (this.isReleaseActive ? (row.ApprovalStatus == 'NEW') : (row.ApprovalStatus == 'RELEASED'))) {
            var selectedReleaseRow = this.mapReleaseRow(row);
            if (ischecked) {
                this.selection.select(row)
                this.onSelect(selectedReleaseRow);
            } else {
                this.selection.deselect(row)
                this.onDeselect(selectedReleaseRow);
            }
        }

    }

    onDetail(element: any) {

        var taxKpiId = "null";

        if (element.KpiId != undefined)
            taxKpiId = element.KpiId;

        const dialog = this.dialogForm.open(KpiDetailFormComponent, {
            panelClass: 'custom-mat-dialog',
            disableClose: false,
            data: {
                "KpiDefinitionId": element.KpiDefinitionId,
                "KpiId": taxKpiId,
                "KpiBreakDown1Id": element.KpiBreakDown1Id,
                "KpiBreakDown2Id": element.KpiBreakDown2Id,
                "KpiMovementTypeId": element.KpiBreakDown2Id,
                "KpiPorductHierarchyId": element.KpiPorductHierarchyId,
                "DataType": 'BUDY',
                "BusinessLevel": 'PE' 
            }
        });
        dialog.afterClosed().subscribe(() => {
        });

    }

    formatCurrency(value, decimalDigits): string {
        if (value == undefined)
            return '';
        else
            return parseFloat(value).toLocaleString('de', { maximumFractionDigits: decimalDigits });
    }

    onChange(account: any, breakdown: any, $e: any, field: string) {
        let tempObject: KpiManagementUpdate = {
            'KpiId': breakdown.KpiId,
            'KpiMovementTypeId': breakdown.KpiMovementTypeId,
            'KpiProductHierarchyId': breakdown.KpiProductHierarchyId,
            'KpiVersion': 'BUDGET',
            'KpiDefinitionId': account.KpiDefinitionId,
            'KpiBreakdown1Id': breakdown.KpiBreakdown1Id,
            'KpiBreakdown2Id': breakdown.KpiBreakdown2Id,
            'KpiValue': parseFloat($e).toFixed(account.DecimalDigits),
            'Field': field,
            'prev_FYFC': breakdown.Prev_FYFC !== null && breakdown.Prev_FYFC !== undefined ? breakdown.Prev_FYFC : 0,
            FY1BUD: "",
            ReportingType: "",
            SumMonthlyValues: 0,
            ApprovalStatus: field !== 'FYFC' ? breakdown.ApprovalStatus : 'NEW',
            KpiUnit: account.KpiUnit,
            DecimalDigits: account.DecimalDigits,
            auxFYFC: breakdown.FYFC,
            IsAccumulative: breakdown.IsAccumulative,
            AccountId: account.AccountID

        }
        this.addUpdatedItem(tempObject);

        if (field === 'FYFC') {
            this.addUpdatedItem({
                'KpiId': breakdown.KpiId,
                'KpiMovementTypeId': breakdown.KpiMovementTypeId,
                'KpiProductHierarchyId': breakdown.KpiProductHierarchyId,
                'KpiVersion': 'BUDGET',
                'KpiDefinitionId': account.KpiDefinitionId,
                'KpiBreakdown1Id': breakdown.KpiBreakdown1Id,
                'KpiBreakdown2Id': breakdown.KpiBreakdown2Id,
                'KpiValue': parseFloat(breakdown.FY1BUD).toFixed(account.DecimalDigits),
                'Field': 'FY1BUD',
                'prev_FYFC': breakdown.Prev_FYFC !== null && breakdown.Prev_FYFC !== undefined ? breakdown.Prev_FYFC : 0,
                FY1BUD: "",
                ReportingType: "",
                SumMonthlyValues: 0,
                ApprovalStatus: field !== 'FYFC' ? breakdown.ApprovalStatus : 'NEW',
                KpiUnit: account.KpiUnit,
                DecimalDigits: account.DecimalDigits,
                auxFYFC: breakdown.FYFC,
                IsAccumulative: breakdown.IsAccumulative,
                AccountId: account.AccountID
            });
        }
    }

    disableArrowKeys(event: KeyboardEvent) {
        if (
            event.key === 'ArrowUp' ||
            event.key === 'ArrowDown'
        ) {
            event.preventDefault();
        }
    }

    anyActionableItemExist() {
        return this.isReleaseActive ?
            this.list.some((kpi) => kpi.KpiDetail.some((kpidef) => (kpidef.ApprovalStatus == "NEW"))) :
            this.list.some((kpi) => kpi.KpiDetail.some((kpidef) => (kpidef.ApprovalStatus == "RELEASED")));
    }

    onClickReleaseMode_emitter() {
        this.onClickReleaseMode.emit();
    }

    onClickRevokeMode_emitter() {
        this.onClickRevokeMode.emit();
    }

    textRelRevButtonState() {
        return this.anyActionableItemExist() ?
            (((this.isReleaseActive || this.isRevokeActive && this.isReleaseActive) ? 'Release ' : 'Revoke ') + (!this.selection.hasValue() ? 'All' : 'Selected')) :
            (this.isReleaseActive ? 'Nothing to Release' : 'Nothing to Revoke')
    }

    getSelectionList() {
        return this.releaseList;
    }

    clearSelectionList() {
        this.releaseList = [];
        this.selection?.clear();
    }

    private createMatSubtable(el: any) {
        let dataSource = new MatTableDataSource<any>();
        dataSource.data = el.KpiDetail
        dataSource.filterPredicate = (data2: any, filters: string) => {
            return this.auxFilterPredicate(filters, data2, false, this.isShowAllEnabled)
        }
        el.subtable = dataSource
    }

    private mapReleaseRow(row) {
        var selectedReleaseRow: selectedReleaseRow = {
            KpiDefinitionId: row.KpiDefinitionId,
            KpiMovementTypeId: row.KpiMovementTypeId,
            KpiProductHierarchyId: row.KpiProductHierarchyId,
            KpiBreakdown1Id: row.KpiBreakdown1Id,
            KpiBreakdown2Id: row.KpiBreakdown2Id,
            User: row.User
        };
        return selectedReleaseRow;
    }

    private onSelect(selectedReleaseRow) {
        if (!this.releaseList.some((object) => this.objectsEqual(object, selectedReleaseRow))) {
            this.releaseList.push(selectedReleaseRow)
        }
    }

    private onDeselect(selectedReleaseRow) {
        var mappedRow = this.mapReleaseRow(selectedReleaseRow)
        const index = this.releaseList.findIndex((object) => this.objectsEqual(mappedRow, object));
        if (index !== -1) {
            this.releaseList.splice(index, 1);
        }
    }

    private objectsEqual(object1, object2) {
        if (object1 === object2) {
            return true;
        }
        if (Object.keys(object1).length !== Object.keys(object2).length) {
            return false;
        }
        for (const property in object1) {
            if (object1[property] !== object2[property]) {
                return false;
            }
        }
        return true;
    }

    private addUpdatedItem(newObject: KpiManagementUpdate) {
        const index = this.updatedItems.findIndex(
            (obj) =>
                obj.KpiDefinitionId === newObject.KpiDefinitionId &&
                obj.KpiBreakdown1Id === newObject.KpiBreakdown1Id &&
                obj.KpiBreakdown2Id === newObject.KpiBreakdown2Id &&
                obj.KpiMovementTypeId === newObject.KpiMovementTypeId &&
                obj.KpiProductHierarchyId === newObject.KpiProductHierarchyId &&
                obj.KpiId === newObject.KpiId &&
                obj.KpiVersion === newObject.KpiVersion &&
                obj.Field === newObject.Field
        );

        if (index !== -1) {
            if (newObject.KpiValue === 'NaN')
                this.updatedItems.splice(index, 1)
            else
                this.updatedItems[index] = newObject;
        } else {
            this.updatedItems.push(newObject);
        }
    }

    private getFiscalYearHeaders() {
        this.FY3 = (this.defaults.fiscalYear + 2).toString() + '-' + (this.defaults.fiscalYear + 3).toString();
        this.FY2 = (this.defaults.fiscalYear + 1).toString() + '-' + (this.defaults.fiscalYear + 2).toString();
        this.FY1 = (this.defaults.fiscalYear).toString() + '-' + (this.defaults.fiscalYear + 1).toString();
        this.currentFY = (this.defaults.fiscalYear - 1).toString() + '-' + (this.defaults.fiscalYear).toString();
    }
}


export interface SearchItem {
    name: string;
}